import {Router} from "@vaadin/router";
import {app} from "../instance.js";
import routes from "../browser-routes.js";

/**
 * @typedef {{pathname:string,search:string,hash:string}} LocationContext
 */

/**
 *
 * @param {HTMLElement} outlet
 * @param {string} routePath
 */
export function initRoutes(outlet, routePath='/home') {

    let router = new Router(outlet);

    app.bindSingleton(Router, () => {
        return router;
    });

    // Pseudo abstraction from vaadin
    window.addEventListener('vaadin-router-go', evt => {
        window.dispatchEvent(new CustomEvent('app::location-changed', {detail: {
            pathname: evt.detail.pathname,
            search: evt.detail.search,
            location: evt.detail.hash,
        }}));
    });

    router.setRoutes(routes).then( () => {
        router.ready.then(() => {
            Router.go(router.urlForPath(routePath));
        });
    });
}